import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import {navigator, router} from 'lit-element-router';

import {when} from 'lit/directives/when.js';

import store from '../../store';

import style from '../../../../scss/accounts.scss';
import formPageStyle from '../../../../scss/formPage.scss';
import arrowRight from '../../icons/arrowRight';
import {navigateTo} from '../../slices/statusSlice';
import getRoutes from '../../routes';
import plus from '../../icons/plus';


@customElement('arc-admin-accounts')
export class AdminAccounts extends connect(store)(router(navigator(LitElement))) {
	static styles = [formPageStyle, style];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.status = state.status;
		this.accountData = state.account.data.account;
		this.accountStatus = state.account.status;
		this.loggedIn = state.account.data.loggedIn;
	}

	static get routes() {
		return getRoutes();
	}

	router(route, params, query, data) {
		this.params = params;
		this.query = query;
	}

	async connectedCallback() {
		super.connectedCallback();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
	}

	handleAddAccount() {
			store.dispatch(navigateTo({route: 'admin-account-create', params: this.params}));
	}

	render() {
		const state = store.getState();
		return html`
			<div class="accounts">
				<arc-toolbar class="toolbar">
					<div slot="left">
						<arc-breadcrumbs>
							<span>${msg('Accounts')}</span>
						</arc-breadcrumbs>
					</div>
					<div slot="right">
						<arc-button
							title="${msg('Create New Account')}"
							type="primary"
							.additionalInfo="${false}"
							showLabel=${true}
							showIcon=${true}
							iconColor="ok"
							@click=${() => this.handleAddAccount()}
						>${plus}</arc-button>
					</div>
				</arc-toolbar>

				${when(
					this.loggedIn,
					() => html`
						<arc-account-list class="accountList" listType="${'all'}" .showSearch="${true}" .showFilter="${true}"></arc-account-list>`,
					() => html`
						<arc-routerlink class="requestToken" route="requestToken">
							${msg('Request Token')}
						</arc-routerlink>
					`
				)}

		`;
	}
}
